module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_location@3x-ed54bf87d9a3a6ef74d4ca82062445c1.webp";